
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue';
  import {
    getProviderProductOrderList
  } from '@/api/order';
  import UploadImg from '@/components/upload-img.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    getOssToken
  } from '@/api/user';
  import {
    logisticsExcel,
    getExpressList,
    transportOrder,
    expressedit
  } from '@/api/logistics';
  import {
    nextDay
  } from "@/utils"

  @Component({
    name: 'order-detail',
    components: {
      PageFooter,
      UploadImg,
      'slz-dialog': Dialog
    }
  })
  export default class OrderDetail extends Vue {
    private productId = +this.$route.query.id;
    private state = this.$route.query.state;
    private list: any = []
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private keyword = '';
    private showImportExel = false;
    private uploadToken: any = {};
    private importUrl = '';
    private excelPwd = '';
    private dialogType = 0;
    private expressList: any = [];
    private currentOrder:any = {};
    private form: any = [{
        ExpressId:'',
        ExpressValue:'',
        ExpressNo:''
      }]

    private mounted() {
      this.getList();
      // this.getToken();
      this.getExpressList();
      // this.showImportExel = true
    }

    // 获取token
    private async getToken() {
      try {
        const res: any = await getOssToken({})
        this.uploadToken = {
          AccessKeySecret: res.access_key_secret,
          OSSAccessKeyId: res.access_key_id,
          SecurityToken: res.security_token
        }
      } catch (e) {
        console.error('getOssToken ===>', e)
      }
    }

    /**
     * 上传成功
     */
    private uploadSuc(list: any) {
      this.importUrl = list[0]
    }

    /**
     * 显示弹窗
     */
    private showLogistics(type: number, row ? : any) {
      this.showImportExel = true;
      this.dialogType = type;
      let list = [
        {
          ExpressId:'',
          ExpressValue:'',
          ExpressNo:''
        }
      ]
      this.form = JSON.parse(JSON.stringify(row.ExpressBasicInfoList.length?row.ExpressBasicInfoList:list))
      this.currentOrder = row;
    }
    private delform(e){
      this.form.splice(e,1)
    }
    private newpush(){
      this.form.push({
        ExpressId:'',
        ExpressValue:'',
        ExpressNo:''
      })
    }

    /**
     * 物流公司
     */
    private async getExpressList() {
      try {
        const res: any = await getExpressList({});
        this.expressList = res.Result || [];
      } catch (e) {
        console.log(e)
      }
    }

    /**
     * 关闭弹窗
     */
    private handleCloseImport() {
      this.showImportExel = false;
      this.form = [{
        ExpressId:'',
        ExpressValue:'',
        ExpressNo:''
      }]
    }

    /**
     * 确认发货
     */
    private async confirmInvoice() {
      if(!this.form||!this.form.length){
        this.$message.error('至少有一个快递单号')
        return
      }
      // let isok = true
      for(let item of this.form){
        // console.log(item)
        if (item.ExpressId !== 37){
          if(!item.ExpressId || !item.ExpressNo){
            this.$message.error('请填写物流信息')
            return
          }
        }
       
      }
      // console.log(isok)
      // if(!isok){
      //   return
      // }
      let params: any = {
        OrderNo: this.currentOrder.OrderNo,
        OrderDetailId: this.currentOrder.OrderDetailId,
        // ExpressId: this.form.Id,
        // ExpressNo: this.form.ExpressNo,
        // SendCount: this.currentOrder.ProductCount,
        ExpressBasicInfoList:this.form
      }
      // console.log(this.form)
      // return
      try {
        if (this.dialogType){
          const res: any = await expressedit(params);
          this.$message({
            type: 'success',
            message: '修改成功'
          })
        }else{
            const res: any = await transportOrder(params);
            this.$message({
              type: 'success',
              message: '发货成功'
            })
        }
       
        this.handleCloseImport()
        this.getList();
      } catch (err) {
        console.log(err);
      }
    }

    /**
     * 获取列表
     */
    private async getList() {
      let params: any = {
        ProductId: this.productId,
        Skip: (this.pageNo-1)*this.pageSize,
        Take: this.pageSize,
        SendState: this.state,
        Keywords: this.keyword,
        StartTime:'',
        EndTime:'',
      }
      if (this.$route.query.filterTime) {
        // console.log(this.$route.query.filterTime)
        let filterTime = this.$route.query.filterTime
        let time = String(filterTime).split('/')
        params.StartTime = time[0]
        params.EndTime = nextDay(time[1],1)
      }
      try {
        const res: any = await getProviderProductOrderList(params);
        this.list = res.Result.Results.map(v=>{
          // console.log( v.ExpressBasicInfoList)
          v.ExpressMsg = v.ExpressBasicInfoList.map(v=>v.ExpressValue+" "+v.ExpressNo).join('; ')
          return v
        });
        // console.log(this.list)
        this.total = res.Result.Total;
      } catch (err) {
        console.log(err);
      }
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      this.pageNo = 1;
      this.keyword = '';
      this.getList();
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }
  }
